import AppLanguage from "../constants/appLanguage.enum";

interface ILanguageItem {
  short: AppLanguage;
  name: string;
}

export const languagesMap = new Map<AppLanguage, string>([
  [AppLanguage.English, "english"],
  [AppLanguage.German, "german"],
  [AppLanguage.French, "french"],
  [AppLanguage.Italian, "italian"],
]);

export const languagesList: ILanguageItem[] = [...languagesMap.entries()].map(([short, name]) => ({ short, name }));
